<template>
    <div id="main-layout">
      <div class="main-header">
        <HeaderLayout/>
      </div>
      <div class="main-box">
        <keep-alive>
          <router-view/>
        </keep-alive>
      </div>
      <div class="main-footer">
        <FooterLayout/>
      </div>
    </div>
  </template>
  <script>
  import HeaderLayout from '@/components/layouts/HeaderLayout'
  import FooterLayout from '@/components/layouts/FooterLayout'
  export default {
    components: {HeaderLayout,FooterLayout}
  }
  </script>
  <style lang="scss">
  #main-layout {
    // font-family: Avenir, Helvetica, Arial, sans-serif;
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
    min-width: 1200px;
    overflow-x: auto;
    .main-box {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
  </style>
  